import { IconUsers as TablerIconUsers } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconUsers = /*#__PURE__*/ createOutlineIcon(TablerIconUsers, 'IconUsers');
